import { FormattedMessage } from 'react-intl';

import { MainSectionWrapper } from '../../../pageStructure/mainSectionWrapper/MainSectionWrapper';
import PendingStatusSVG from '../../../multiLoanDashboard/pendingView/pendingStatusSVG/PendingStatusSVG';
import messages from './PendingView.messages';
import styles from './PendingView.module.css';

const PendingView = () => (
    <MainSectionWrapper>
        <div className={styles.pendingStatus}>
            <PendingStatusSVG className={styles.PendingViewSVG} />

            <div className={styles.title}>
                <FormattedMessage {...messages.title} />
            </div>

            <div className={styles.subtitle}>
                <FormattedMessage {...messages.subtitle} />
            </div>
        </div>
    </MainSectionWrapper>
);

// eslint-disable-next-line import/no-default-export
export default PendingView;
